import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Download } from "lucide-react";

export const DescargaFichaje = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className="px-6 py-14 md:py-16" style={{ background: "linear-gradient(135deg, #1B2B4B 0%, #00B4CC 100%)" }} data-testid="descarga-fichaje-section">
      <div className="max-w-4xl mx-auto text-center text-white">
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight" data-testid="descarga-fichaje-titulo">{t("home.apps.qrTitle")}</h2>
        <p className="mt-3 text-base md:text-lg text-white/85" data-testid="descarga-fichaje-subtitulo">{t("home.apps.qrSubtitle")}</p>
        <div className="mt-8 mx-auto max-w-xl bg-white rounded-3xl shadow-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6" data-testid="descarga-fichaje-card">
          <img src="/qr-nuvlipro-fichaje.png" alt="QR de descarga de NuvliPro FICHAJE" width="200" height="200"
            className="w-48 h-48 sm:w-52 sm:h-52 shrink-0 rounded-xl border border-slate-200 bg-white p-1.5" data-testid="descarga-fichaje-qr" />
          <div className="flex-1 text-center sm:text-left">
            <p className="text-lg font-bold text-[#1B2B4B]" data-testid="descarga-fichaje-texto">{t("home.apps.qrText")}</p>
            <a href="https://www.nuvlipro.com" className="inline-block mt-1 text-lg font-bold text-[#00B4CC] hover:underline" data-testid="descarga-fichaje-url">www.nuvlipro.com</a>
            <div>
              <button onClick={() => navigate("/app")} className="mt-4 inline-flex items-center gap-2 h-12 px-6 rounded-xl bg-[#00C853] hover:bg-[#00A844] text-white font-semibold shadow-lg shadow-emerald-900/20 transition-colors" data-testid="descarga-fichaje-instalar">
                <Download className="w-5 h-5" /> {t("home.apps.qrInstall")}
              </button>
            </div>
            <p className="mt-2 text-xs text-slate-500" data-testid="descarga-fichaje-disponible">{t("home.apps.qrAvailable")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
